const eventCallbacks: { [event: string]: { [id: string]: Function } } = {}

export const registerEventCallback = (event: string, id: string, callback: Function) => {
    if (!eventCallbacks[event]) eventCallbacks[event] = {}
    eventCallbacks[event][id] = callback
}

export const unregisterEventCallback = (event: string, id: string) => {
    delete eventCallbacks[event][id]
}
export const getEventCallbacks = (event: string) => {
    return eventCallbacks[event]
}
